/** @jsxImportSource preact */
import type { ProductCardData } from '../types';
import type { ActionHandler } from './types';
import { ProductCard } from './ProductCard';

interface ProductGridProps {
  products: ProductCardData[];
  onAction: ActionHandler;
  /** Optional editorial eyebrow above the carousel (e.g. "Seleccionado para vos"). */
  eyebrow?: string;
}

/**
 * Editorial horizontal carousel of `<ProductCard>`s (3:4 imagery, peek,
 * scroll-snap). Cards have no inline add button — tapping one emits a
 * `view-product` intent that the widget host turns into a product detail
 * view. Reuses the `.lc-products-carousel` class so the shell CSS applies.
 */
export function ProductGrid({ products, onAction, eyebrow }: ProductGridProps) {
  if (!products || products.length === 0) return null;

  return (
    <div class="lc-carousel-block">
      {eyebrow ? <p class="lc-eyebrow">{eyebrow}</p> : null}
      <div class="lc-products-carousel">
        {products.map((product) => (
          <ProductCard
            key={product.product_id}
            product={product}
            onView={(p: ProductCardData) => onAction({ kind: 'view-product', product: p })}
          />
        ))}
      </div>
    </div>
  );
}
